export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11530.8eff6378.jpg";